import { ServiceConfigItemTypes } from '../common/constants'
import type { ConfigItem } from '../common/types'
import type { ConfigItemSource } from './types'

// Normalize the raw descriptors a v1 service declares via `addService` into the canonical `ConfigItem`
// shape returned to the console (resolving legacy `hint`/`displayName` aliases and filling defaults).
export function normalizeConfigItems(sourceConfigItems?: ConfigItemSource[]): ConfigItem[] {
  return sourceConfigItems?.map(item => ({
    name: item.name,
    type: item.type || ServiceConfigItemTypes.STRING,
    shared: !!item.shared,
    required: !!item.required,
    description: item.description || item.hint || '',
    label: item.label || item.displayName || item.name,
    defaultValue: item.defaultValue,
    options: item.options || [],
  })) || []
}
